export const selectProgramContentLibrary = (state) => {
  return state.programContentLibrary;
};

export const selectProgramContentLibraryMeta = (state) => {
  return selectProgramContentLibrary(state).meta;
};

export const selectProgramContentLibraryEntries = (state) => {
  return selectProgramContentLibrary(state).entries;
};
